import {
    combineReducers,
    configureStore
} from "@reduxjs/toolkit";
import houseCardsHeardReducer from "./reducers/houseCardsHeardSlice";
import houseCardsHeardNotesReducer from "./reducers/houseCardsHeardNotesSlice";
import listingDataReducer from "./reducers/listingDataSlice"; // Import the new reducer

const combinedReducer = combineReducers({
    houseCardsHeard: houseCardsHeardReducer,
    houseCardsHeardNotes: houseCardsHeardNotesReducer,
    listingData: listingDataReducer,
});

const rootReducer = (state, action) => {
    return combinedReducer(state, action);
};

export const setupStore = () => {
    return configureStore({
        reducer: rootReducer,
    });
};